(() => {
  var __typeError = (msg) => {
    throw TypeError(msg);
  };
  var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
  var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
  var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
  var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
  var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);

  // src-kombuchery/assets/js/_debug.js
  var isDev = window.location.hostname === "127.0.0.1" || window.location.hostname.endsWith(".test") || window.location.hostname.includes("shopifypreview.com");
  (() => {
    if (isDev) {
      window.Shopify.theme.id = "173777387788";
    }
  })();
  var kbyDebug = (...args) => {
    if (isDev) console.debug(...args);
  };
  window.kbyIsDev = isDev;
  window.kbyDebug = kbyDebug;

  // src-kombuchery/assets/js/_patch-cart-items.js
  var overrideCartItems = (() => {
    const CartItems = customElements.get("cart-items");
    if (!CartItems) {
      window.setTimeout(overrideCartItems, 10);
      return;
    }
    CartItems.prototype._validateQuantity = CartItems.prototype.validateQuantity;
    CartItems.prototype.validateQuantity = function(event) {
      const target = event.target;
      const inputValue = parseInt(target.value);
      const index = target.getAttribute("data-index");
      if (inputValue <= 0) {
        this.updateQuantity(index, 0);
        return;
      }
      return this._validateQuantity(event);
    };
  });
  overrideCartItems();

  // src-kombuchery/assets/js/_patch-product-info.js
  Object.defineProperty(ProductInfo.prototype, "sellingPlanId", {
    get: function() {
      const kbySubscriptionSelector = this.querySelector("kby-subscription-selector");
      return kbySubscriptionSelector == null ? void 0 : kbySubscriptionSelector.sellingPlanId;
    }
  });
  ProductInfo.prototype._buildRequestUrlWithParams = ProductInfo.prototype.buildRequestUrlWithParams;
  ProductInfo.prototype.buildRequestUrlWithParams = function(url, optionValues) {
    let requestUrl = this._buildRequestUrlWithParams(url, optionValues);
    if (this.sellingPlanId) {
      requestUrl += `&selling_plan=${this.sellingPlanId}`;
    }
    return requestUrl;
  };
  ProductInfo.prototype._handleUpdateProductInfo = ProductInfo.prototype.handleUpdateProductInfo;
  ProductInfo.prototype.handleUpdateProductInfo = function() {
    const parsedHtmlCallback = this._handleUpdateProductInfo();
    return (parsedHtml) => {
      this.updateSourceFromDestination(parsedHtml, "KbyBasePrice");
      this.updateSourceFromDestination(parsedHtml, "KbyStickySellingPlan");
      this.updateSourceFromDestination(parsedHtml, "KbySubscriptionSelector");
      this.updateSourceFromDestination(parsedHtml, "KbyVariantPicker");
      [...this.querySelectorAll("[data-kby-keypoint-id]")].map((kbyKeypoint) => kbyKeypoint.dataset.kbyKeypointId).forEach((keypointId) => {
        this.updateSourceFromDestination(parsedHtml, `KbyKeypoint-${keypointId}`);
      });
      return parsedHtmlCallback(parsedHtml);
    };
  };
  ProductInfo.prototype.updateURL = function(variant) {
    if (!(variant == null ? void 0 : variant.id) || this.getAttribute("data-update-url") === "false") return;
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set("variant", variant.id);
    if (this.sellingPlanId) newUrl.searchParams.set("selling_plan", this.sellingPlanId);
    else newUrl.searchParams.delete("selling_plan");
    window.history.replaceState({ path: newUrl.toString() }, "", newUrl.toString());
  };
  ProductInfo.prototype._updateSourceFromDestination = ProductInfo.prototype.updateSourceFromDestination;
  ProductInfo.prototype.updateSourceFromDestination = function(parsedHTML, id) {
    const source = parsedHTML.getElementById(`${id}-${this.sectionId}-${this.productId}`);
    const destination = document.querySelector(`#${id}-${this.sectionId}-${this.productId}`);
    if (!source || !destination) return;
    if (source.innerHTML === destination.innerHTML) return;
    if (id === "ProductGallery") {
      const hasDiff = (() => {
        const sourceImages = source.querySelectorAll("img:not(video img)");
        const destinationImages = destination.querySelectorAll("img:not(video img)");
        if (sourceImages.length !== destinationImages.length) return true;
        for (let i = 0; i < sourceImages.length; i++) {
          if (sourceImages[i].src !== destinationImages[i].src) return true;
        }
        return false;
      })();
      if (!hasDiff) return;
    }
    return this._updateSourceFromDestination(parsedHTML, id);
  };

  // src-kombuchery/assets/js/_patch-media-gallery.js
  MediaGallery.prototype._setActiveMedia = MediaGallery.prototype.setActiveMedia;
  MediaGallery.prototype.setActiveMedia = function(mediaId) {
    let activeMedia = this.sliderGallery.querySelector(`[data-media-id="${mediaId}"]`);
    if ((activeMedia == null ? void 0 : activeMedia.checkVisibility()) === false) {
      activeMedia = activeMedia.nextElementSibling;
    }
  };
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("media-gallery").forEach((mediaGallery) => {
      var _a, _b;
      mediaGallery.lastVariant = (_b = (_a = mediaGallery.productForm) == null ? void 0 : _a.variantIdInput) == null ? void 0 : _b.value;
    });
  });

  // src-kombuchery/assets/js/_deposit.js
  var kbyDebug2 = window.kbyDebug || (() => {
  });
  var kbyApplyDeposit = () => {
    if (window.location.host != "kombuchery.test" && window.location.host != "kombuchery.de") return;
    const redirectCartChangeToCartUpdate = async (originalFetch, resource, options) => {
      var _a, _b, _c;
      let body;
      if (typeof options.body === "string") {
        body = JSON.parse(options.body);
      } else if (options.body instanceof FormData) {
        body = Object.fromEntries(options.body.entries());
      } else {
        console.warn("redirectCartChangeToCartUpdate: body is not a string or FormData", options.body);
        return originalFetch(resource, options);
      }
      let cart;
      try {
        cart = await (await originalFetch(window.theme.routes.cart_url, { ...theme.utils.fetchConfig("json", "GET") })).json();
      } catch (err) {
        return Promise.reject(err);
      }
      const variantLineItem = cart.items.find((item) => item.key === body.id);
      if (!variantLineItem) {
        console.warn("redirectCartChangeToCartUpdate: variant line item not found", { body, items: cart.items });
        return originalFetch(resource, options);
      }
      const variantDepositPerUnit = (_a = window.kbyDepositVariantData[variantLineItem.id]) == null ? void 0 : _a.deposit_amount;
      if (!variantDepositPerUnit) {
        return originalFetch(resource, options);
      }
      const variantSellingPlanId = (_c = (_b = variantLineItem.selling_plan_allocation) == null ? void 0 : _b.selling_plan) == null ? void 0 : _c.id;
      let depositSellingPlanId = void 0;
      if (variantSellingPlanId) {
        const variantSellingPlanName = window.kbyDepositVariantData[variantLineItem.id].selling_plan_names[variantSellingPlanId];
        depositSellingPlanId = window.kbyDepositData.deposit_selling_plans[variantSellingPlanName];
      }
      const variantQuantityChange = body.quantity - variantLineItem.quantity;
      const depositQuantityChange = variantQuantityChange * variantDepositPerUnit;
      const depositLineItem = cart.items.find((item) => {
        var _a2, _b2;
        return item.variant_id === window.kbyDepositData.deposit_variant_id && ((_b2 = (_a2 = item.selling_plan_allocation) == null ? void 0 : _a2.selling_plan) == null ? void 0 : _b2.id) == depositSellingPlanId;
      });
      if (!depositLineItem) {
        console.warn("redirectCartChangeToCartUpdate: deposit line item not found");
      }
      const newCart = {
        updates: {
          [variantLineItem.key]: body.quantity
        },
        sections: body.sections,
        sections_url: body.sections_url
      };
      if (depositLineItem) {
        newCart.updates[depositLineItem.key] = depositLineItem.quantity + depositQuantityChange;
      }
      return originalFetch(window.theme.routes.cart_update_url, {
        ...theme.utils.fetchConfig("json", "POST"),
        body: JSON.stringify(newCart)
      });
    };
    const adjustCartAddReqBodyForDeposit = async (body) => {
      if (typeof body === "string") {
        body = JSON.parse(body);
      } else if (body instanceof FormData) {
        body = Object.fromEntries(body.entries());
      } else {
        console.warn("adjustCartRequestBodyForDeposit: body is not a string or FormData", body);
        return body;
      }
      if (!body.items) {
        body.items = [
          {
            id: parseInt(body.id),
            quantity: parseInt(body.quantity) || 1,
            selling_plan: body.selling_plan ? parseInt(body.selling_plan) : void 0
          }
        ];
        delete body.id;
        delete body.quantity;
        delete body.selling_plan;
      }
      const expectedDeposits = {};
      body.items.forEach((item) => {
        kbyDebug2(`DEPOSIT: Checking for item ${item.id}`);
        if (!window.kbyDepositVariantData[item.id]) {
          kbyDebug2(`DEPOSIT: item ${item.id} has no deposit`);
          return;
        }
        const sellingPlan = (() => {
          if (!item.selling_plan) return "ONETIME";
          const sellingPlanName = window.kbyDepositVariantData[item.id].selling_plan_names[item.selling_plan];
          const sellingPlanId = window.kbyDepositData.deposit_selling_plans[sellingPlanName];
          if (!sellingPlanId) {
            kbyDebug2("adjustCartRequestBodyForDeposit: selling plan not found", item.selling_plan, sellingPlanName);
            return "ONETIME";
          }
          return sellingPlanId;
        })();
        kbyDebug2(`DEPOSIT: item ${item.id} has ${window.kbyDepositVariantData[item.id].deposit_amount} deposits for selling plan ${sellingPlan}`);
        expectedDeposits[sellingPlan] = (expectedDeposits[sellingPlan] || 0) + item.quantity * window.kbyDepositVariantData[item.id].deposit_amount;
      });
      Object.keys(expectedDeposits).forEach((depositSellingPlan) => {
        const depositAmount = expectedDeposits[depositSellingPlan];
        const existingDepositLineItem = body.items.find((item) => item.id === window.kbyDepositData.deposit_variant_id && (depositSellingPlan == "ONETIME" && !item.selling_plan || item.selling_plan === depositSellingPlan));
        if (existingDepositLineItem) {
          existingDepositLineItem.quantity = depositAmount;
        } else {
          body.items.push({
            id: window.kbyDepositData.deposit_variant_id,
            quantity: depositAmount,
            selling_plan: depositSellingPlan === "ONETIME" ? void 0 : depositSellingPlan
          });
        }
      });
      return JSON.stringify(body);
    };
    const adjustCartUpdateReqBodyForDeposit = async (originalFetch, body) => {
      let adjustedBody = body;
      if (typeof adjustedBody === "string") {
        try {
          adjustedBody = JSON.parse(adjustedBody);
        } catch (e) {
          try {
            adjustedBody = Object.fromEntries(new URLSearchParams(adjustedBody));
          } catch (e2) {
            console.warn("adjustCartUpdateReqBodyForDeposit: string body is neither JSON nor URL search params", adjustedBody);
            return body;
          }
        }
      } else if (adjustedBody instanceof FormData) {
        adjustedBody = Object.fromEntries(adjustedBody.entries());
      } else {
        console.warn("adjustCartUpdateReqBodyForDeposit: body is not a string or FormData", adjustedBody);
        return body;
      }
      if (!adjustedBody.updates) {
        console.warn("adjustCartUpdateReqBodyForDeposit: body does not contain updates", adjustedBody);
        return body;
      }
      let cart;
      try {
        cart = await (await originalFetch(window.theme.routes.cart_url, { ...theme.utils.fetchConfig("json", "GET") })).json();
      } catch (err) {
        return Promise.reject(err);
      }
      let expectedDeposit = {};
      Object.keys(adjustedBody.updates).forEach((lineItemId) => {
        var _a, _b, _c;
        kbyDebug2(`DEPOSIT: checking for line item ${lineItemId}`);
        let variantLineItem = cart.items.find((item) => item.key === lineItemId);
        if (!variantLineItem) {
          variantLineItem = cart.items.find((item) => item.id == lineItemId);
        }
        if (!variantLineItem) {
          kbyDebug2(`DEPOSIT: variant line item not found for ${lineItemId}`);
          return;
        }
        const variantDepositPerUnit = (_a = window.kbyDepositVariantData[variantLineItem.id]) == null ? void 0 : _a.deposit_amount;
        if (!variantDepositPerUnit) {
          return;
        }
        kbyDebug2(`DEPOSIT: line item ${lineItemId} has ${window.kbyDepositVariantData[variantLineItem.id].deposit_amount} deposits`);
        const variantSellingPlanId = (_c = (_b = variantLineItem.selling_plan_allocation) == null ? void 0 : _b.selling_plan) == null ? void 0 : _c.id;
        let depositSellingPlanId = void 0;
        if (variantSellingPlanId) {
          const variantSellingPlanName = window.kbyDepositVariantData[variantLineItem.id].selling_plan_names[variantSellingPlanId];
          depositSellingPlanId = window.kbyDepositData.deposit_selling_plans[variantSellingPlanName];
        }
        const variantQuantityChange = adjustedBody.updates[lineItemId] - variantLineItem.quantity;
        const depositQuantityChange = variantQuantityChange * variantDepositPerUnit;
        const depositLineItem = cart.items.find((item) => {
          var _a2, _b2;
          return item.variant_id === window.kbyDepositData.deposit_variant_id && ((_b2 = (_a2 = item.selling_plan_allocation) == null ? void 0 : _a2.selling_plan) == null ? void 0 : _b2.id) == depositSellingPlanId;
        });
        if (!depositLineItem) {
          kbyDebug2("adjustCartUpdateReqBodyForDeposit: deposit line item not found");
        }
        expectedDeposit[depositLineItem.key] = (expectedDeposit[depositLineItem.key] || depositLineItem.quantity || 0) + depositQuantityChange;
      });
      Object.keys(expectedDeposit).forEach((depositLineItemKey) => {
        adjustedBody.updates[depositLineItemKey] = expectedDeposit[depositLineItemKey];
      });
      return JSON.stringify(adjustedBody);
    };
    function install(factory) {
      if (window.__fetchChain) return window.__fetchChain.add(factory);
      var prev = window.fetch.bind(window);
      window.fetch = factory(prev);
      return prev;
    }
    install(function(originalFetch) {
      return async function(resource, options) {
        const domains = [
          window.location.origin,
          "https://kombuchery.myshopify.com"
        ];
        let normalizedResource = resource;
        domains.forEach((domain) => {
          if (normalizedResource.startsWith(domain)) {
            normalizedResource = normalizedResource.replace(domain, "");
          }
        });
        try {
          switch (normalizedResource) {
            case window.theme.routes.cart_add_url:
            case "/cart/add.js":
            case "/cart/add.js?vex=true":
              options.body = await adjustCartAddReqBodyForDeposit(options.body);
              options.headers["Content-Type"] = "application/json";
              break;
            case window.theme.routes.cart_change_url:
              return redirectCartChangeToCartUpdate(originalFetch, resource, options);
            case "/cart/update.js":
            case "/cart/update.js?vex=true":
              options.body = await adjustCartUpdateReqBodyForDeposit(originalFetch, options.body);
              options.headers["Content-Type"] = "application/json";
              break;
          }
        } catch (e) {
          console.error("Error intercepting request to " + normalizedResource, e);
        }
        return originalFetch(normalizedResource, options);
      };
    });
    CartCount.prototype._onCartUpdate = CartCount.prototype.onCartUpdate;
    CartCount.prototype.onCartUpdate = function(event) {
      event.cart.item_count = event.cart.items.reduce((count, item) => {
        if (item.variant_id === window.kbyDepositData.deposit_variant_id) return count;
        return count + item.quantity;
      }, 0);
      return this._onCartUpdate(event);
    };
    document.querySelectorAll("cart-count").forEach((cartCount) => {
      cartCount.disconnectedCallback();
      cartCount.connectedCallback();
    });
    const kbyApplyProductRecommendationsExtraScripts = (productRecommendationsEl) => {
      const scripts = productRecommendationsEl.querySelectorAll("script[data-kby-deposit-variant-data]");
      scripts.forEach((script) => {
        const newScript = document.createElement("script");
        newScript.textContent = script.textContent;
        newScript.setAttribute("data-kby-deposit-variant-data", "");
        script.parentNode.replaceChild(newScript, script);
      });
      if (window.reinitialiseRatingSnippet) window.reinitialiseRatingSnippet();
    };
    document.querySelectorAll("product-recommendations").forEach((pe) => pe.addEventListener("recommendations:loaded", () => kbyApplyProductRecommendationsExtraScripts(pe)));
    document.addEventListener("cart:updated", () => {
      document.querySelectorAll("product-recommendations").forEach((pe) => pe.addEventListener("recommendations:loaded", () => kbyApplyProductRecommendationsExtraScripts(pe)));
    });
  };
  kbyApplyDeposit();

  // src-kombuchery/assets/js/_countdown.js
  var KbyCountdown = class extends HTMLElement {
    constructor() {
      super();
      const targetDate = /* @__PURE__ */ new Date();
      targetDate.setDate(targetDate.getDate() + 1);
      targetDate.setHours(0, 0, 0, 0);
      this.dayEl = this.querySelector('[data-kby-countdown="day"]');
      this.hourEl = this.querySelector('[data-kby-countdown="hour"]');
      this.minEl = this.querySelector('[data-kby-countdown="min"]');
      this.secEl = this.querySelector('[data-kby-countdown="sec"]');
      this.dayNumEl = this.dayEl.querySelector(".kby-countdown__num");
      this.hourNumEl = this.hourEl.querySelector(".kby-countdown__num");
      this.minNumEl = this.minEl.querySelector(".kby-countdown__num");
      this.secNumEl = this.secEl.querySelector(".kby-countdown__num");
      const updateTime = () => {
        const now = (/* @__PURE__ */ new Date()).getTime();
        const distance = targetDate - now;
        const days = Math.floor(distance / (1e3 * 60 * 60 * 24));
        const hours = Math.floor(distance % (1e3 * 60 * 60 * 24) / (1e3 * 60 * 60));
        const minutes = Math.floor(distance % (1e3 * 60 * 60) / (1e3 * 60));
        const seconds = Math.floor(distance % (1e3 * 60) / 1e3);
        this.dayNumEl.innerHTML = this._addZero(days);
        this.hourNumEl.innerHTML = this._addZero(hours);
        this.minNumEl.innerHTML = this._addZero(minutes);
        this.secNumEl.innerHTML = this._addZero(seconds);
        if (distance < 0) {
          this.dayNumEl.innerHTML = "00";
          this.hourNumEl.innerHTML = "00";
          this.minNumEl.innerHTML = "00";
          this.secNumEl.innerHTML = "00";
        }
        requestAnimationFrame(updateTime);
      };
      updateTime();
    }
    _addZero(num) {
      return num.toString().padStart(2, "0");
    }
  };
  window.customElements.define("kby-countdown", KbyCountdown);

  // src-kombuchery/assets/js/_manual-video.js
  var _KbyManualVideo_instances, togglePlayState_fn;
  var KbyManualVideo = class {
    constructor(el) {
      __privateAdd(this, _KbyManualVideo_instances);
      this.el = el;
      this.el.addEventListener("click", __privateMethod(this, _KbyManualVideo_instances, togglePlayState_fn).bind(this));
    }
  };
  _KbyManualVideo_instances = new WeakSet();
  togglePlayState_fn = function(event) {
    event.preventDefault();
    event.stopPropagation();
    if (!this.el.playing) this.el.play();
    else this.el.pause();
  };
  [...document.querySelectorAll("video-media")].forEach((videoMediaEl) => new KbyManualVideo(videoMediaEl));

  // src-kombuchery/assets/js/_typewriter.js
  var KbyTypewriter = class extends HTMLElement {
    static get observedAttributes() {
      return ["data-delay", "data-duration", "data-start", "data-type", "data-values"];
    }
    constructor() {
      super();
      this._initialized = false;
      this.cursor = null;
    }
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this.applyAttributes();
      Motion.inView(this, () => this.init());
    }
    applyAttributes() {
      var _a, _b, _c, _d, _e, _f;
      this.cursor = this.hasAttribute("data-cursor");
      this.delay = Number((_a = this.getAttribute("data-delay")) != null ? _a : 1);
      this.duration = Number((_b = this.getAttribute("data-duration")) != null ? _b : 1);
      this.start = Number((_c = this.getAttribute("data-start")) != null ? _c : 0);
      this.type = (_d = this.getAttribute("data-type")) != null ? _d : "countup";
      this.values = (_f = (_e = this.getAttribute("data-values")) == null ? void 0 : _e.split(";")) != null ? _f : [""];
      this.current = this.start;
    }
    async init() {
      if (this.cursor) this.insertCursor();
      this.showNext();
    }
    async showNext() {
      let displayText = "";
      switch (this.type) {
        case "countup":
          displayText = Intl.NumberFormat().format(this.current);
          this.current += 1;
          break;
        case "loop":
          displayText = this.values[this.current];
          this.current += 1;
          if (this.current >= this.values.length) this.current = 0;
          break;
      }
      this.innerHTML = displayText;
      await Motion.animate(this, { width: [0, `${this.scrollWidth + 5}px`] }, { duration: this.duration }).finished;
      await Motion.animate(this, { width: 0 }, { duration: this.duration, delay: this.delay }).finished;
      this.showNext();
    }
    insertCursor() {
      if (!this.cursor) return;
      this.cursor = document.createElement("span");
      this.cursor.className = "kby-typewriter__cursor";
      this.cursor.setAttribute("aria-hidden", true);
      this.cursor.innerHTML = "|";
      this.parentElement.insertBefore(this.cursor, this.nextSibling);
    }
  };
  customElements.define("kby-typewriter", KbyTypewriter);
  var kbyParseTypewriters = () => {
    const TAG = "kby-typewriter";
    const MARK = "data-kby-processed";
    const PATTERN = /\[kby:typewriter\|([^\]]+)\]/g;
    function parseArgs(str) {
      const data = {};
      str.split("|").forEach((part) => {
        const [key, value] = part.split("=");
        if (!key) return;
        data[key] = (value == null ? void 0 : value.includes(",")) ? value.split(",") : value;
      });
      return data;
    }
    function process(root = document.body) {
      const walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode(node2) {
            if (!node2.parentElement) return NodeFilter.FILTER_REJECT;
            if (node2.parentElement.closest(TAG)) return NodeFilter.FILTER_REJECT;
            if (node2.parentElement.hasAttribute(MARK)) return NodeFilter.FILTER_REJECT;
            if (!PATTERN.test(node2.textContent)) return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        }
      );
      let node;
      while (node = walker.nextNode()) {
        const textContent = node.textContent;
        const fragment = document.createDocumentFragment();
        let lastIndex = 0;
        textContent.replace(PATTERN, (full, args, index) => {
          fragment.append(textContent.slice(lastIndex, index));
          const newTypewriterEl = document.createElement(TAG);
          const elData = parseArgs(args);
          for (const [dataKey, dataValue] of Object.entries(elData)) {
            newTypewriterEl.dataset[dataKey] = Array.isArray(dataValue) ? JSON.stringify(dataValue) : dataValue || true;
          }
          fragment.append(newTypewriterEl);
          lastIndex = index + full.length;
        });
        fragment.append(textContent.slice(lastIndex));
        node.parentElement.setAttribute(MARK, "");
        node.replaceWith(fragment);
      }
    }
    process();
  };
  kbyParseTypewriters();

  // src-kombuchery/assets/js/_klaviyo-images.js
  var kbyParseKlaviyoImages = () => {
    if (document.querySelectorAll("[class^='klaviyo-form-']").length) {
      let prepareKlaviyoImgUpload2 = function() {
        if (!document.querySelectorAll(".klaviyo-form input").length) {
          window.setTimeout(prepareKlaviyoImgUpload2, 100);
          return;
        }
        const imageInputs = [...document.querySelectorAll(".klaviyo-form input[placeholder^='[img]'")];
        if (!imageInputs.length) return;
        if (!window.Upload) {
          if (!document.querySelector("#uploadio-js-script")) {
            const script = document.createElement("script");
            script.id = "uploadio-js-script";
            script.src = "https://js.upload.io/upload-js/v2";
            document.head.appendChild(script);
          }
          window.setTimeout(prepareKlaviyoImgUpload2, 100);
          return;
        }
        let uploadInstance = Upload({ apiKey: "public_223k2XJEy9nxWo4BYW2p3TQpSgC2" });
        imageInputs.forEach((input) => {
          let isUploading = false;
          let placeholder = input.placeholder.replace("[img]", "");
          input.placeholder = placeholder;
          input.style.cursor = "pointer";
          input.setAttribute("readonly", true);
          const fileInput = document.createElement("input");
          fileInput.type = "file";
          fileInput.accept = "image/*,.pdf";
          fileInput.style.display = "none";
          input.parentNode.insertBefore(fileInput, input);
          fileInput.addEventListener("change", (event) => {
            if (event.target.files.length === 0) return;
            isUploading = true;
            input.placeholder = "Lade hoch...";
            try {
              uploadInstance.uploadFile(
                event.target.files[0],
                {
                  onProgress: ({
                    progress
                  }) => input.placeholder = `Lade hoch... ${progress}%`
                }
              ).then((result) => {
                input.value = result.fileUrl;
                input.dispatchEvent(new Event("input"));
                input.style.pointerEvents = "none";
                input.style.display = "none";
                const img = document.createElement("img");
                img.src = result.fileUrl;
                img.style.height = "auto";
                img.style.maxHeight = "400px";
                img.style.width = "100%";
                img.style.objectFit = "contain";
                img.style.display = "block";
                img.style.margin = "0 auto";
                img.style.border = "1px solid rgb(180, 187, 195)";
                img.style.borderRadius = "4px";
                input.parentNode.insertBefore(img, input);
                isUploading = false;
              });
            } catch (error) {
              alert(`Fehler:
${error.message}`);
              isUploading = false;
              input.placeholder = placeholder;
            }
          });
          input.addEventListener("click", () => {
            if (isUploading) return;
            fileInput.click();
          });
        });
      };
      var prepareKlaviyoImgUpload = prepareKlaviyoImgUpload2;
      prepareKlaviyoImgUpload2();
    }
  };
  kbyParseKlaviyoImages();

  // src-kombuchery/assets/js/_patch-countdown-timer.js
  Object.defineProperty(CountdownTimer.prototype, "date", {
    get: function() {
      if (this._date) return this._date;
      if (this.getAttribute("data-expires") == "midnight") {
        const midnightDate = /* @__PURE__ */ new Date();
        midnightDate.setDate(midnightDate.getDate() + 1);
        midnightDate.setHours(0, 0, 0, 0);
        return this._date = midnightDate;
      }
      return this._date = new Date(this.getAttribute("data-expires"));
    }
  });

  // src-kombuchery/assets/js/_cart-ui.js
  if (window.location.hash == "#cart") {
    window.location.hash = "";
    const kbyShowCart = () => {
      const cartDrawerEl = document.querySelector("cart-drawer");
      if (!cartDrawerEl || typeof cartDrawerEl.show !== "function") {
        setTimeout(kbyShowCart, 50);
        return;
      }
      cartDrawerEl.show();
    };
    kbyShowCart();
  }
  MenuDrawer.prototype._beforeShow = MenuDrawer.prototype.beforeShow;
  MenuDrawer.prototype.beforeShow = function() {
    this._beforeShow();
    this.querySelector('[is="accordion-details"]').open = true;
  };
  var CartDrawerGift = class extends HTMLElement {
    constructor() {
      super();
      const addToCartBtn = this.querySelector("[data-add-to-cart]");
      addToCartBtn.addEventListener("click", (event) => {
        var _a, _b;
        event.preventDefault();
        let id = (_a = this.dataset.variantId) != null ? _a : null;
        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent("cart:bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
        const parentEl = addToCartBtn.closest("[data-threshold]");
        let threshold;
        if (parentEl && !!((_b = parentEl.getAttribute("data-threshold")) == null ? void 0 : _b.length)) {
          threshold = Math.floor(+parentEl.getAttribute("data-threshold") / 100).toFixed(0);
        }
        const body = JSON.stringify({
          quantity: 1,
          id,
          sections: sectionsToBundle,
          properties: {
            "_gift": "yes",
            ...threshold ? { "_threshold": threshold } : {}
          }
        });
        fetch(`${theme.routes.cart_add_url}`, { ...theme.utils.fetchConfig(), ...{ body } }).then((response) => response.json()).then(async (parsedState) => {
          const cartJson = await (await fetch(`${theme.routes.cart_url}`, { ...theme.utils.fetchConfig() })).json();
          cartJson["sections"] = parsedState["sections"];
          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  };
  customElements.define("kby-cart-gift", CartDrawerGift);

  // src-kombuchery/assets/js/_subscription-selector.js
  var _changeEventHandler, _documentClickHandler, _KbySubscriptionSelector_instances, init_fn, openPopover_fn, handleDocumentClick_fn, shortenOptions_fn, handleSellingPlanChange_fn;
  var KbySubscriptionSelector = class extends HTMLElement {
    constructor() {
      super();
      __privateAdd(this, _KbySubscriptionSelector_instances);
      // TODO: refactor to make nicer maybe
      __privateAdd(this, _changeEventHandler);
      __privateAdd(this, _documentClickHandler);
      this.productId = this.dataset.productId;
      this.hasSubscription = this.dataset.hasSubscription === "true";
      __privateSet(this, _documentClickHandler, __privateMethod(this, _KbySubscriptionSelector_instances, handleDocumentClick_fn).bind(this));
      __privateSet(this, _changeEventHandler, __privateMethod(this, _KbySubscriptionSelector_instances, handleSellingPlanChange_fn).bind(this));
    }
    connectedCallback() {
      document.addEventListener("click", __privateGet(this, _documentClickHandler));
      this.addEventListener("change", __privateGet(this, _changeEventHandler));
      __privateMethod(this, _KbySubscriptionSelector_instances, init_fn).call(this);
    }
    disconnectedCallback() {
      document.removeEventListener("click", __privateGet(this, _documentClickHandler));
      this.removeEventListener("change", __privateGet(this, _changeEventHandler));
    }
    updateSellingPlanInput(sellingPlanId) {
      const input = this.productForm.querySelector('input[name="selling_plan"]');
      input.value = sellingPlanId != null ? sellingPlanId : "";
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
    get productForm() {
      return document.forms[this.getAttribute("form")];
    }
    get productInfo() {
      return this.closest("product-info");
    }
    get variantPicker() {
      var _a;
      return (_a = this.productInfo) == null ? void 0 : _a.querySelector("variant-picker");
    }
    get sellingPlanId() {
      const selectedRadio = this.querySelector('[type="radio"]:checked');
      if (selectedRadio) {
        return selectedRadio.value;
      }
      const sellingPlanSelect = this.querySelector("select[data-selling-plan-id]");
      return sellingPlanSelect == null ? void 0 : sellingPlanSelect.value;
    }
  };
  _changeEventHandler = new WeakMap();
  _documentClickHandler = new WeakMap();
  _KbySubscriptionSelector_instances = new WeakSet();
  init_fn = function() {
    __privateMethod(this, _KbySubscriptionSelector_instances, shortenOptions_fn).call(this);
    if (window[`kbyLastSellingPlanId_${this.productId}`]) {
      const select = this.querySelector("select[data-selling-plan-id]");
      const expectedSellingPlan = window[`kbyLastSellingPlanId_${this.productId}`];
      if (select.querySelector(`option[value="${expectedSellingPlan}"]`)) {
        select.value = expectedSellingPlan;
      }
    }
    this.querySelector(".kby-subscription-selector__infoButton").addEventListener("click", __privateMethod(this, _KbySubscriptionSelector_instances, openPopover_fn).bind(this));
    const subscriptionRadio = this.querySelector("[data-selling-plan-subscription]");
    if (!window[`kbySellingPlanDisabled_${this.productId}`] && subscriptionRadio && !subscriptionRadio.checked) {
      subscriptionRadio.click();
    }
  };
  openPopover_fn = function(event) {
    event.stopPropagation();
    const popoverEl = this.querySelector(".kby-subscription-selector__infoPopover");
    if (popoverEl == null ? void 0 : popoverEl.classList.contains("--open")) popoverEl == null ? void 0 : popoverEl.classList.remove("--open");
    else popoverEl == null ? void 0 : popoverEl.classList.add("--open");
  };
  handleDocumentClick_fn = function(event) {
    const popoverEl = this.querySelector(".kby-subscription-selector__infoPopover");
    if (!(popoverEl == null ? void 0 : popoverEl.classList.contains("--open"))) {
      return;
    }
    const infoButton = this.querySelector(".kby-subscription-selector__infoButton");
    const clickedInsidePopover = popoverEl.contains(event.target);
    const clickedInfoButton = infoButton == null ? void 0 : infoButton.contains(event.target);
    if (!clickedInsidePopover && !clickedInfoButton) {
      popoverEl.classList.remove("--open");
    }
  };
  shortenOptions_fn = function() {
    ;
    [...this.querySelectorAll("select[data-selling-plan-id] option")].forEach((option) => {
      option.textContent = option.textContent.replace(/Lieferung alle (\d+) Wochen?/, "$1 Wochen");
    });
  };
  handleSellingPlanChange_fn = function(event) {
    var _a;
    if (event.target.tagName === "SELECT") {
      const subscriptionRadio = this.querySelector("[data-selling-plan-subscription]");
      if (subscriptionRadio) {
        subscriptionRadio.value = event.target.value;
        subscriptionRadio.checked = true;
      }
    }
    if (event.target.value) {
      window[`kbyLastSellingPlanId_${this.productId}`] = event.target.value;
      window[`kbySellingPlanDisabled_${this.productId}`] = false;
    } else {
      window[`kbySellingPlanDisabled_${this.productId}`] = true;
    }
    this.updateSellingPlanInput(event.target.value);
    const selectedOptionValues = ((_a = this.variantPicker) == null ? void 0 : _a.selectedOptionValues) || [];
    theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
      data: {
        event,
        target: this,
        selectedOptionValues
      }
    });
  };
  customElements.define("kby-subscription-selector", KbySubscriptionSelector);

  // src-kombuchery/assets/js/_loop-bundle.js
  var KbyLoopBundle = class extends HTMLElement {
    constructor() {
      super();
      this.loopBundleId = this.dataset.loopBundleId;
    }
    connectedCallback() {
      let bundleUrl = null;
      const bundleId = new URLSearchParams(window.location.search).get("loopBundleId");
      if (bundleId) {
        bundleUrl = `${BUNDLE_LINK_PREFIX}/change/${bundleId}`;
      } else if (this.loopBundleId) {
        bundleUrl = `${BUNDLE_LINK_PREFIX}/${this.loopBundleId}`;
      }
      console.log("bundleUrl", bundleUrl);
      if (!bundleUrl) return;
      fetch(bundleUrl).then((r) => r.text()).then((html) => {
        const selectors = [
          "#__st",
          "#loop",
          "[data-kby-deposit-variant-data]",
          '#MainContent link[rel="stylesheet"]',
          '#MainContent script[src^="https://cdn.loopwork.co/"]'
        ];
        const doc = new DOMParser().parseFromString(html, "text/html");
        selectors.forEach((selector) => {
          doc.querySelectorAll(selector).forEach((el) => {
            if (el.tagName === "SCRIPT") {
              const script = document.createElement("script");
              for (const attr of el.attributes) {
                script.setAttribute(attr.name, attr.value);
              }
              if (!el.src) {
                script.textContent = el.textContent;
              }
              script.async = false;
              this.appendChild(script);
              return;
            }
            if (el.tagName === "LINK") {
              const link = document.createElement("link");
              for (const attr of el.attributes) {
                link.setAttribute(attr.name, attr.value);
              }
              this.appendChild(link);
              return;
            }
            this.appendChild(el.cloneNode(true));
            if (bundleId) {
              setTimeout(() => {
                this.scrollIntoView();
              }, 100);
            }
          });
        });
      });
    }
    disconnectedCallback() {
      this.innerHTML = "";
    }
  };
  customElements.define("kby-loop-bundle", KbyLoopBundle);
  (() => {
    const successSelector = ".toast-container .bg-green-100";
    const reloadPageWithCart = () => {
      window.location.hash = "#cart";
      window.location.reload();
    };
    const observer = new MutationObserver(() => {
      if (document.querySelector(successSelector)) {
        reloadPageWithCart();
        return;
      }
      let editBtns = [...document.querySelectorAll(".LOOP_BUNDLE_DRAWER_CONTAINER_CLASS button[onclick]")];
      if (editBtns.length) {
        editBtns.forEach((editBtn) => {
          const onclickData = editBtn.getAttribute("onclick");
          const bundleIdParsing = onclickData.match(/'([A-Z0-9]+)'/);
          if (!(bundleIdParsing == null ? void 0 : bundleIdParsing.length)) {
            return;
          }
          const bundleId = bundleIdParsing[1];
          editBtn.removeAttribute("onclick");
          editBtn.addEventListener("click", () => {
            window.location = `/pages/mix-save?loopBundleId=${bundleId}`;
          });
        });
        return;
      }
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  })();
})();
